import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const DocumentRead = async (docid) => {
  try {
    console.log(docid);
    const data = JSON.stringify({
      svc: "KYC",
      pid: "DocumentRead",
      dat: {
        docid: docid,
        // list: list,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DocumentStatus = async (userid, list) => {
  try {
    console.log(list);
    const data = JSON.stringify({
      svc: "KYC",
      pid: "UpdateConsumerProfile",
      dat: {
        userid: userid,
        list: list,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getKYCData = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "KYC",
      pid: "crmKYCList",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateStatus = async (docData) => {
  try {
    const data = JSON.stringify({
      svc: "KYC",
      pid: "crmKYCUpdate",
      dat: {
        userid: docData.userid,
        groupid: docData.groupid,
        verified: docData.verified,
      }
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const idScan = async (docid, userid, idfront) => {
  try {
    const data = JSON.stringify({
      svc: "KYC",
      pid: "ThisismeIdScan",
      dat: {
        location: '',
        docid: docid,
        userid: userid,
        idfront: idfront
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const thisIsMePhotoCompare = async (docid, userid, idphoto, idphotocompare) => {
  try {
    const data = JSON.stringify({
      svc: "KYC",
      pid: "ThisismePhotoCompare",
      dat: {
        location: '',
        docid: docid,
        userid: userid,
        idphoto: idphoto,
        idphotocompare: idphotocompare
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const DocumentNew = async (userid, imagedata, doctype, groupid, docname) => {
  console.log(userid);
  try {
    const data = JSON.stringify({
      svc: "KYC",
      pid: "DocumentNew",
      dat: {
        userid: userid,
        imagedata: imagedata,
        doctype: doctype,
        groupid: groupid,
        name: docname
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
  }
};
